<script setup lang='ts'>
import { KsExpandItem } from '@aschehoug/kloss'
</script>

<template>
  <Accordion size="small">
    <KsExpandItem level="div">
      <template #prefix>
        <h5>Kontakt</h5>
      </template>
      <template #content>
        <a v-for="(item, key) in LAYOUT_CONTACT_URLS" :key="key" :href="item.url" class="px-s py-xs flex">
          {{ item.label }}
        </a>
        <span v-for="(item, key) in LAYOUT_VISIT" :key="key" class="px-s py-xs flex">
          {{ item }}
        </span>
      </template>
    </KsExpandItem>
    <KsExpandItem level="div">
      <template #prefix>
        <h5>Informasjon</h5>
      </template>
      <template #content>
        <NuxtLink v-for="(item, key) in LAYOUT_FOOTER_LINKS" :key="key" :to="item.url" class="flex px-s py-xs !no-underline hover:!underline">
          {{ item.label }}
        </NuxtLink>
      </template>
    </KsExpandItem>
    <KsExpandItem level="div">
      <template #prefix>
        <h5> En tjeneste fra</h5>
      </template>
      <template #content>
        <FooterAuthor />
      </template>
    </KsExpandItem>
  </Accordion>
  <div class="flex gap-l px-2xs">
    <SocialLink v-for="provider in SOCIAL_PROVIDERS" :key="provider" class="dark:text-carbon-200" :provider="provider" />
  </div>
</template>
